// Cookie consent management utility
// Update this version when the cookie policy changes to re-prompt users
export const COOKIE_POLICY_VERSION = "1.0.0";

export interface CookieConsent {
  version: string;
  essential: boolean;
  functional: boolean;
  analytics: boolean;
  timestamp: number;
}

/**
 * Get the current cookie consent preferences
 */
export function getCookieConsent(): CookieConsent | null {
  try {
    const consentStr = localStorage.getItem("cookie_consent");
    if (!consentStr) return null;
    
    const consent: CookieConsent = JSON.parse(consentStr);
    return consent;
  } catch (error) {
    console.error("Error reading cookie consent:", error);
    return null;
  }
}

/**
 * Check if cookie consent has been given for the current policy version
 */
export function hasValidCookieConsent(): boolean {
  const consent = getCookieConsent();
  return consent !== null && consent.version === COOKIE_POLICY_VERSION;
}

/**
 * Clear cookie consent (useful for testing or resetting)
 */
export function clearCookieConsent(): void {
  localStorage.removeItem("cookie_consent");
}

/**
 * Update cookie consent preferences
 */
export function updateCookieConsent(preferences: Partial<Pick<CookieConsent, 'functional' | 'analytics'>>): void {
  const current = getCookieConsent();
  
  const newConsent: CookieConsent = {
    version: COOKIE_POLICY_VERSION,
    essential: true,
    functional: preferences.functional ?? current?.functional ?? true,
    analytics: preferences.analytics ?? current?.analytics ?? true,
    timestamp: Date.now(),
  };
  
  localStorage.setItem("cookie_consent", JSON.stringify(newConsent));
}
